export async function GetGoalGroupsApi(evalId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const url = evalId 
      ? `${process.env.REACT_APP_API_URL}v1/ehrm/goal-groups?evalId=${evalId}`
      : `${process.env.REACT_APP_API_URL}v1/ehrm/goal-groups`;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
        Authorization: token,
      },
    };

    await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error get goal groups: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
